import { pxToRem } from '../../../../lib';
export default (function (siteVars) {
  return {
    borderColor: siteVars.colorScheme.default.border2,
    borderRadius: pxToRem(3),
    borderSize: '1px',
    boxShadow: siteVars.shadowLevel3,
    padding: "".concat(pxToRem(10), " ").concat(pxToRem(14)),
    pointerOffset: pxToRem(5),
    pointerMargin: pxToRem(10),
    pointerSize: pxToRem(10)
  };
});